/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import VeeValidate, {ExtendOptions, Validator} from 'vee-validate';
import {FileSizeValidator} from '@/validators/file-size';
import {FileCountValidator} from '@/validators/file-count';
import {Plaintext} from '@/validators/plaintext';
import Vue from 'vue';
import {TextQualityValidator} from '@/validators/text-quality';

/**
 * Validator initialisation module.
 *
 * Initialises and adds custom validation rules to vee-validate Validator.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

// add vee-validation components
Vue.use(VeeValidate, {fieldsBagName: 'formFields'});

// add file size validation rule
Validator.extend('fileSize', FileSizeValidator, {paramNames: ['size']} as ExtendOptions);

// add file count validation rule
Validator.extend('fileCount', FileCountValidator, {paramNames: ['count']} as ExtendOptions);

// check text meets Frontier guidelines
Validator.extend('textQuality', TextQualityValidator);

// add file count validation rule
Validator.extend('plaintext', Plaintext);
